define( [
	"../../var/pnum"
], function( pnum ) {
	"use strict";

	return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rnumnonpx.js
// module id = 1544
// module chunks = 37